import React from 'react';
import { string } from 'prop-types';
import { Tag } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';

const EducationTooltipTitle = ({ titleKey, tagKey }) => (
    <>
        <I18n k={titleKey} />
        {tagKey && (
            <Tag color={Tag.COLORS.BLUE} theme={Tag.THEMES.HOLLOW} className="m-l-8">
                <I18n k={tagKey} />
            </Tag>
        )}
    </>
);

EducationTooltipTitle.propTypes = {
    titleKey: string.isRequired,
    tagKey: string,
};

export default EducationTooltipTitle;
